export default __webpack_public_path__ + "static/media/1.17ccb511.png";